import { Currency } from "@redotech/money/currencies";
import { localizedPaymentMethodTypeSchema } from "@redotech/redo-billing-common/payout";
import * as z from "zod";

export const getLocalizedBillingStatus = {
  name: "getLocalizedBillingStatus" as const,
  input: z.object({}),
  output: z.discriminatedUnion("available", [
    z.object({ available: z.literal(false) }),
    z.object({
      available: z.literal(true),
      currency: z.enum(Currency),
      publishableKey: z.string(),
      paymentMethodTypes: z.array(localizedPaymentMethodTypeSchema),
      paymentMethod: z
        .object({
          type: localizedPaymentMethodTypeSchema,
          brand: z.string().nullable(),
          last4: z.string().nullable(),
          expMonth: z.number().nullable(),
          expYear: z.number().nullable(),
        })
        .nullable(),
    }),
  ]),
};
